import React from 'react'

function Header() {
  return (
    <div className='container-box-2'>
    <h2>Hello</h2>
     <p>Hello, I am Barbaro.  after having graduated 
     from technical school in Cuba for a long time, 
      my job was to fix desktop computers, but from a very young age. 
      I felt the desire to learn the magic of programming until it became an inescapable 
      desire almost 3 years ago. now  I live in the beautiful city of Austin,
       a place that opened its doors for me to make my dreams come true</p> 

      <img alt='' src='https://www.google.com/maps/vt/data=5P4ONVexKCVOBj0TGShKJUHHEh92mCYp-iiYNH_ToCyE8lC8bKwnonJSUN8d9dMOASkgYIV0qOpY3MUAayvO3A7tQNMsawDb5NRKT6lbg5B71CZnmDhT0aA1rBBk9vKekI1JNuqLmj1SQgfPUx0lvmqOPTcg8Z4V3WCHXdacXOuQsphQpEnVjuv7R1HRi1FcOCG1Xr1g7ryrq2hclzzfAMf3UakE-PxCA9l0RJ7kvrwB_KbL3ZEzIZg'/>
    </div>
  )
}

export default Header
